interface AmountSettings {
    valueType?: 'number' | 'currency' | 'percentage'
    currency?: string
    decimals?: number | string
}

interface KedoLocaleAccessor {
    env: () => {
        getSelectedLocale: () => { code?: string } | null
    }
}

const DUTCH_LOCALE = 'nl-NL'
const DEFAULT_DECIMALS = 2

export const getAmountLocale = (kedo: KedoLocaleAccessor): string => {
    const locale = kedo.env().getSelectedLocale()

    return locale?.code ? locale.code.replace('_', '-') : DUTCH_LOCALE
}

export const formatAmountValue = (
    value: unknown,
    settings: AmountSettings = {},
    locale = DUTCH_LOCALE
): string | null => {
    if (value === null || value === undefined || value === '') return null

    const amount = Number(
        typeof value === 'string' ? value.trim().replace(',', '.') : value
    )
    if (!Number.isFinite(amount)) return String(value)

    const configuredDecimals = Number(settings.decimals)
    const decimals =
        settings.decimals !== '' &&
        settings.decimals !== null &&
        settings.decimals !== undefined &&
        Number.isInteger(configuredDecimals) &&
        configuredDecimals >= 0 &&
        configuredDecimals <= 20
            ? configuredDecimals
            : DEFAULT_DECIMALS
    const options: Intl.NumberFormatOptions = {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
    }

    if (settings.valueType === 'currency' && settings.currency) {
        options.style = 'currency'
        options.currency = settings.currency
    }

    let formatted: string

    try {
        formatted = new Intl.NumberFormat(locale, options).format(amount)
    } catch {
        try {
            formatted = new Intl.NumberFormat(DUTCH_LOCALE, options).format(
                amount
            )
        } catch {
            formatted = new Intl.NumberFormat(DUTCH_LOCALE, {
                minimumFractionDigits: decimals,
                maximumFractionDigits: decimals,
            }).format(amount)
        }
    }

    return settings.valueType === 'percentage'
        ? `${formatted}\u00A0%`
        : formatted
}
